import { render, staticRenderFns } from "./FamilyInfo.vue?vue&type=template&id=12118225&"
import script from "./FamilyInfo.vue?vue&type=script&lang=js&"
export * from "./FamilyInfo.vue?vue&type=script&lang=js&"
import style0 from "./FamilyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports